import { render, staticRenderFns } from "./bindType.vue?vue&type=template&id=6b1fe682"
import script from "./bindType.vue?vue&type=script&lang=js"
export * from "./bindType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports